import { styled } from '@mui/system';
import { DataGrid as DataGridMui } from '@mui/x-data-grid';

export const GridContainer = styled('div')<{ hideMargin?: boolean }>(({ hideMargin }) => ({
    display: 'flex',
    margin: hideMargin ? '0' : '0px 90px'
}));

export const InnerGrid = styled('div')({
    flexGrow: 1
});

export const DataGrid = styled(DataGridMui)<any>({
    '& .MuiDataGrid-main': {
        border: '2px solid #E9EAEE',
        borderRadius: '5px'
    },
    '& .MuiDataGrid-columnsContainer': {
        color: '#1C3D64',
        backgroundColor: '#F0F1F4'
    },
    '& .MuiDataGrid-cell': {
        borderBottom: '2px solid #E9EAEE'
    },
    '& .MuiTooltip': {
        color: 'red'
    },
    '& .MuiIconButton-root': {
        padding: '4px',
        margin: '8px'
    },
    '& .MuiDataGrid-columnHeadersInner': {
        backgroundColor: '#F0F1F4'
    },
    '& .MuiDataGrid-columnHeader': {
        backgroundColor: '#F0F1F4'
    },
    '& .MuiDataGrid-cell:focus-within, & .MuiDataGrid-cell:focus': {
        outline: 'none'
    },
    '& .MuiDataGrid-columnHeader:focus-within, & .MuiDataGrid-columnHeader:focus': {
        outline: 'none'
    }
});
